import React from 'react';
import { useLocation } from 'react-router-dom';
import GameMetricsReport from './GameMetricsReport';
import GameStickinessReport from './GameStickinessReport';
import GamePerformanceReport from './GamePerformanceReport';
import GameAskAI from './GameAskAI';
import GameReleasesReport from './GameReleasesReport';
import PreReleaseBenchmarkReport from './PreReleaseBenchmarkReport';

const REPORTS_BY_PATH = {
  '/game-department/stickiness': GameStickinessReport,
  '/game-department/performance': GamePerformanceReport,
  '/game-department/releases': GameReleasesReport,
  '/game-department/pre-release-benchmark': PreReleaseBenchmarkReport,
  '/game-department/ask-ai': GameAskAI,
};

export default function GameDepartmentPage() {
  const { pathname } = useLocation();
  const Report = REPORTS_BY_PATH[pathname] || GameMetricsReport;

  return (
    <div className="max-w-[1100px] mx-auto">
      <h2 className="text-lg font-bold text-ink mb-1">Game Dashboard</h2>
      <p className="text-xs text-ink-dim mb-4">
        Reporting for the Game Dashboard. More reports will land here as they're connected.
      </p>

      <Report />
    </div>
  );
}
